// LLM Session Manager - Early loading shim
// Initializes prototype extensions and shows UX test popover if ?ux= param present.

import "@tento-ui/llm-logger-ui";
import "@tento-ui/ui/ux-test-popover";

import { Tracing } from "@tento-core/tracing";

import { initHtmlElement } from "@tento-ui/init/html-element.global";
import { Cookies } from "@tento-ui/cookies";
import { LlmLoggerApi } from "@tento-ui/llm-logger-api";
import { LLMLogger } from "@tento-ui/llm-logger";

initHtmlElement();

// Initialize LlmLoggerApi early (routes are at /_/ prefix, same-origin on all subdomains)
LlmLoggerApi.init();

// Read tracing session ID from URL param or cookie (survives auth redirects)
const tid =
  new URLSearchParams(window.location.search).get("tid") ??
  Cookies.get("ux-tracing-id") ??
  undefined;

// Initialize client tracing (uploads LJSON entries for server-side grafting)
Tracing.configure({ uploadUrl: "/api/tracing/entries", sessionId: tid });

// Initialize session IMMEDIATELY (synchronously) to capture logs from component initialization
// Don't wait for DOMContentLoaded - components may already be loading.
// (initFromUrlParam also registers the headless `window.__lonaUxComplete` hook for
// `ux-test run --auto`, so it is present wherever a ?ux= session activates.)
LLMLogger.initFromUrlParam();
